import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero/hero";
import Services from "../components/services/Services";
import ContactUs from "../components/contactUs/ContactUs";
import AccountingPackage from "../components/accountingPackage/AccountingPackage";
import AddonServices from "../components/addOnServices/AddonServices";
import ContactSuggestion from "../components/ContactSuggestion/ContactSuggestion";
import PackagePricingTable from "../components/PackagePricingTable/PackagePricingTable";
import Faq from "../components/FAQ/Faq";
import articles from "../data/articles";

const Home = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowScrollToTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="site-home">
      <div id="home"><Hero /></div>
      <div id="services"><Services /></div>
      <div id="priser"><AccountingPackage /><PackagePricingTable /><AddonServices /><ContactSuggestion /></div>
      <section id="about" className="site-about">
        <div className="site-container site-about-grid">
          <div><p className="site-eyebrow">Om THAS Redovisning</p><h2>En personlig partner<br />i din företagsvardag.</h2></div>
          <div><p>THAS Ekonomi och Redovisning hjälper dig med allt från löpande bokföring och löner till bokslut, årsredovisning och deklarationer.</p><p>Med fokus på trygghet och kvalitet gör vi ekonomin enklare att förstå och hantera. Tillsammans hittar vi ett upplägg som passar din verksamhet.</p><Link className="site-text-link" to="/#contact">Låt oss prata om ditt företag <span aria-hidden="true">↗</span></Link></div>
        </div>
      </section>
      <Faq />
      <section className="thas-home-guides" aria-labelledby="home-guides-heading">
        <div className="site-container">
          <p className="site-eyebrow">Kunskap & guider</p>
          <div className="thas-home-guides-heading">
            <h2 id="home-guides-heading">Få bättre koll på ekonomin.</h2>
            <Link className="site-text-link" to="/blogg">Alla guider <span aria-hidden="true">↗</span></Link>
          </div>
          <div className="thas-home-guide-list">
            {articles.map((article) => <article className="thas-home-guide" key={article.path}>
              <p className="site-eyebrow">{article.category}</p>
              <h3><Link to={article.path}>{article.title}</Link></h3>
              <p>{article.description}</p>
              <Link className="site-text-link" to={article.path} aria-label={`Läs guiden: ${article.title}`}>Läs guiden <span aria-hidden="true">↗</span></Link>
            </article>)}
          </div>
        </div>
      </section>
      <div id="contact"><ContactUs /></div>
      {showScrollToTop && <button className="site-back-to-top" type="button" aria-label="Till toppen av sidan" onClick={() => window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })}>↑</button>}
    </div>
  );
};
export default Home;
